import { render, staticRenderFns } from "./Stage1.vue?vue&type=template&id=eccbf2f4&"
import script from "./Stage1.vue?vue&type=script&lang=js&"
export * from "./Stage1.vue?vue&type=script&lang=js&"
import style0 from "./Stage1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports